import { message } from 'antd';
import * as intl from 'react-intl-universal';
import errors from 'common/utils/http/errors';
import { ICookieUserInfo } from '../../../types/auth';

const redirectToRootUrl = () => {
    window.location.href = '/';
};

export const verifyCookieUserInfoStatus = async (cookieUserInfo: ICookieUserInfo) => {
    if (!cookieUserInfo) {
        await message.error(intl.get(errors['2800']));
        redirectToRootUrl();
        return;
    }

    if (cookieUserInfo.otherLogin && !cookieUserInfo.maintainer) {
        await message.error(intl.get(errors['2801']));
        redirectToRootUrl();
        return;
    }

    if (cookieUserInfo.UpdateStatus) {
        await message.error(intl.get(errors['2802']));
        redirectToRootUrl();
    }
};
